export default __webpack_public_path__ + "static/media/MSKLogo_fff.0187b8dd.png";